import { connect } from 'react-redux'

import AreaOptions from '../../components/areas/area-options.js'

import { toggleRequireImages, deleteServicing, markServicingAsHighPriority, markServicingAsLowPriority } from '../../actions/servicings'

import { push } from 'react-router-redux'

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.servicingId]
  const transferable = state.workOrders[servicing.workOrderId].backlog

  return {
    servicing,
    transferable
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    deleteServicing () {
      dispatch(deleteServicing(ownProps.servicingId))
    },

    markServicingAsLowPriority () {
      dispatch(markServicingAsLowPriority(ownProps.servicingId))
    },

    markServicingAsHighPriority () {
      dispatch(markServicingAsHighPriority(ownProps.servicingId))
    },

    toggleRequireImages () {
      dispatch(toggleRequireImages(ownProps.servicingId))
    },

    transferServicing () {
      const url = `${ownProps.urlPath.pathname}/transfer-area/${ownProps.servicingId}`

      dispatch(push(url))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaOptions)



// WEBPACK FOOTER //
// ./src/containers/areas/area-options-container.js